// Shared Leaflet basemap configuration. Every map in the app draws the same
// basemap, so the tile URL and its attribution live in one place. Standard
// OpenStreetMap tiles: free and keyless. (Carto Positron, used previously,
// now watermarks every tile with "API KEY REQUIRED" unless a paid key is
// sent.) OSM's tile usage policy allows light use such as this internal
// dashboard; the `{s}` subdomain form is deprecated, so the bare host is used.
export const TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
export const TILE_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
